//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region IMR Imports

import { IMRPopupOptions, IMRPopupHidingArgs } from '@imr/controls.angularjs/components/overlay/popup'

//#endregion

import { TypeHelper, LocalizationHelper } from "../../../../helpers"

import { IMRBaseOverlayControlController } from "../../base"
import { IMRConfirmationPopupOptions, IIMRConfirmationPopup, IMRConfirmationPopupInitializedArgs, IMRConfirmationPopupResult } from '../../confirmation-popup2'
import { GridOptions } from '../../grid'

import { IMREditGridOptions, IMREditGridInitializedArgs, IIMREditGrid } from "../edit-grid/edit-grid.interfaces"
import { IMREditGridPopupOptions, IIMREditGridPopup } from "./edit-grid.popup.interfaces"

export class IMREditGridPopupController<TSourceItem, TTargetItem>
    extends
    IMRBaseOverlayControlController<IIMREditGridPopup<TSourceItem, TTargetItem>, IMREditGridPopupOptions<TSourceItem, TTargetItem>>
    implements
    IIMREditGridPopup<TSourceItem, TTargetItem> {

    //#region Lifecycle

    protected initialize(options: IMREditGridPopupOptions<TSourceItem, TTargetItem>): JQueryPromise<void> {
        return super.initialize(options)
    }

    protected customizePopupOverlay(popupOptions: IMRPopupOptions): void {
        popupOptions.onHiding = TypeHelper.wrapAndCall(popupOptions.onHiding, (e: IMRPopupHidingArgs) => {
            this.onPopupHiding(e)
        })

        popupOptions.innerOptions = _.assign({}, popupOptions.innerOptions, {
            title: this.createPopupTitle(),
        })

        popupOptions.innerOptions.onHidden = TypeHelper.wrapAndCall(popupOptions.innerOptions.onHidden, () => {
            this.onPopupHidden()
        })
    }

    protected initializeOverlayContent(): JQueryPromise<void> {
        this.popup.toggleLoading(true)

        return $.when(
            this.initializeEditGrid(),
            this.initializeConfirmationPopup()
        ).then(() => {
            this.popup.toggleLoading(false)
        })
    }

    //#endregion


    //#region IIMREditGridPopup Implementation

    public getEditGrid(): IIMREditGrid<TSourceItem, TTargetItem> {
        return this.editGrid
    }

    //#endregion


    //#region Component

    private createPopupTitle(): string {
        let itemsCount: number = 0

        if (this.editGrid != null) {
            itemsCount = this.editGrid.getTargetGrid().dxGrid.totalCount()
        }

        return `${this.options.title} (${itemsCount})`
    }

    //#endregion


    //#region Confirmation Popup

    public confirmationPopupOptions: IMRConfirmationPopupOptions
    private confirmationPopup: IIMRConfirmationPopup

    private initializeConfirmationPopup(): JQueryPromise<void> {
        this.confirmationPopupOptions = {
            content: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AreYouSure),
            title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.UnsavedChanges),

            onInitialized: (e: IMRConfirmationPopupInitializedArgs) => {
                this.confirmationPopup = e.component
            }
        }

        return TypeHelper.onInitializedAll(this.confirmationPopupOptions)
    }

    //#endregion


    //#region EditGrid

    public editGridOptions: IMREditGridOptions<TSourceItem, TTargetItem>
    private editGrid: IIMREditGrid<TSourceItem, TTargetItem>

    private initializeEditGrid(): JQueryPromise<any> {
        this.editGridOptions = this.options.editGridOptions

        if (this.editGridOptions.targetGridOptions == null) {
            this.editGridOptions.targetGridOptions = {} as GridOptions
        }

        this.editGridOptions.targetGridOptions.onContentReady = TypeHelper.wrapAndCall(this.editGridOptions.targetGridOptions.onContentReady, () => {
            this.onTargetGridContentReady()
        })

        return super
            .waitForOnInitialized(this.editGridOptions)
            .then((e: IMREditGridInitializedArgs<TSourceItem, TTargetItem>) => {
                this.editGrid = e.component
            })
    }

    private onTargetGridContentReady(): void {
        this.updatePopupTitle()
    }

    //#endregion


    //#region Popup

    private onPopupHiding(e: IMRPopupHidingArgs): void {
        if (this.editGrid.hasChanges()) {
            e.cancelAsync = this.confirmationPopup
                .show()
                .then((result: IMRConfirmationPopupResult) => {
                    return result.declined || result.canceled
                })
        }
    }

    private onPopupHidden(): void {
        if (this.editGrid.hasChanges()) {
            this.editGrid.reset()
        }
    }

    private updatePopupTitle(): void {
        this.popup.getInnerPopup().option('title', this.createPopupTitle())
    }

    //#endregion
}